import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { StackView } from '../StackView';
export function Alert(props) {
  var children = props.children,
      type = props.type,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "type"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    padding: 1,
    radius: 3 // @ts-ignore
    ,
    stroke: type + "-dark",
    strokeAlign: "inside",
    strokeWeight: 1,
    color: "dark-9" // @ts-ignore
    ,
    backgroundColor: type + "-lighter"
  }, restProps), children);
}
export default Alert;